import useManageMyBookingCallback from './utils/useManageMyBookingCallback';
import useWebCheckInCallback from './utils/useWebCheckInCallback';
import ManageMyBookingFullWidthBanner from './components/ManageMyBookingFullWidthBanner';
import WebCheckInFullWidthBanner from './components/WebCheckInFullWidthBanner';
import OnboardFullWidthBanner from './components/OnboardFullWidthBanner';
import useOnboardCallback from '../../utils/onboardUpgrade/useOnboardCallback';
export interface TopOfPageCustomizationAreaProps {
  dataTestId?: string;
}

const TopOfPageCustomizationArea: React.FC<TopOfPageCustomizationAreaProps> = ({ dataTestId }) => {
  const { showWebCheckInBanner } = useWebCheckInCallback().states;
  const { showManageMyBookingBanner } = useManageMyBookingCallback().states;
  const { showOnboardBanner } = useOnboardCallback().states;

  return (
    <>
      {showManageMyBookingBanner && <ManageMyBookingFullWidthBanner dataTestId={dataTestId} />}
      {showWebCheckInBanner && <WebCheckInFullWidthBanner dataTestId={dataTestId} />}
      {showOnboardBanner && <OnboardFullWidthBanner dataTestId={dataTestId} />}
    </>
  );
};

export default TopOfPageCustomizationArea;
